import { centsToDollars, formatCurrency } from '~/shared/lib/currency'
import { Text } from '~/shared/ui'
import { ProgressItem } from './progress-item'

interface ProgressTrackerProps {
  totalClaims: number | undefined
  validatedClaims: number
  totalPaidCents: number
  allocatedCents: number
  deductedCents?: number
  isNonFinancial?: boolean
}

export function ProgressTracker({
  totalClaims,
  validatedClaims,
  totalPaidCents,
  allocatedCents,
  deductedCents = 0,
  isNonFinancial = false,
}: ProgressTrackerProps) {
  const effectiveTotalCents = totalPaidCents + deductedCents

  return (
    <div className="flex gap-8">
      <ProgressItem
        totalValue={totalClaims}
        value={validatedClaims}
        label="to validate"
        summaryLabel="Total Claims"
      />
      {!isNonFinancial && (
        <ProgressItem
          totalValue={centsToDollars(effectiveTotalCents) ?? undefined}
          value={centsToDollars(allocatedCents) ?? 0}
          summaryTotalValue={centsToDollars(totalPaidCents) ?? undefined}
          label="to allocate"
          summaryLabel="EOB paid"
          formatValue={formatCurrency}
          infoTipContent={
            deductedCents > 0 ? (
              <Text
                className="text-text-secondary max-w-[180px] pr-6"
                appearance="CAPTION"
              >
                Includes {formatCurrency(centsToDollars(deductedCents) ?? 0)} in payment adjustments
                deducted from total paid
              </Text>
            ) : undefined
          }
        />
      )}
    </div>
  )
}
